import Rule from './rule';

export default class StripSpacesRule extends Rule {
  constructor(ruleText, attribute,active) {
    super(ruleText, attribute,active);
      this.ruleType = 'STRIP SPACES';
  }
  run(input) {
      return input.replace(/\s/g, '');
  }
}
